var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM3.49999 3.50001C3.67257 3.32743 3.9524 3.32743 4.12499 3.50001L5.99999 5.37502L7.87501 3.49999C8.0476 3.3274 8.32742 3.3274 8.50001 3.49999C8.6726 3.67258 8.6726 3.95241 8.50001 4.125L6.62499 6.00002L8.5 7.87502C8.67258 8.04761 8.67258 8.32743 8.5 8.50002C8.32741 8.67261 8.04758 8.67261 7.87499 8.50002L5.99999 6.62502L4.125 8.5C3.95242 8.67259 3.67259 8.67259 3.5 8.5C3.32741 8.32741 3.32741 8.04759 3.5 7.875L5.37499 6.00002L3.49999 4.12502C3.3274 3.95243 3.3274 3.6726 3.49999 3.50001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/subtract.d47723013d3a9dfe96bcc1aa9d2c3445.svg";
export { ForwardRef as ReactComponent };